import { render, staticRenderFns } from "./UserGroupManagement.vue?vue&type=template&id=6bd8c72b&"
import script from "./UserGroupManagement.vue?vue&type=script&lang=js&"
export * from "./UserGroupManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports